import React, { useState, useEffect, useCallback } from 'react';
import { generateUniqueKey } from '../../utils/uniqueKeyGenerator';
import { connect } from 'react-redux';
import _, { values } from 'lodash';
import { LoadingBlueLarge } from 'merchant-portal-components';
import PaginationControl from '../Pagination/PaginationControl';
import { Button } from 'merchant-portal-components';
import {
  Checkbox,
  TextField,
  InputAdornment,
  Switch,
  FormControlLabel,
} from '@material-ui/core';
import { Dialog } from '@material-ui/core';
import {
  StyledCard,
  HeaderWrapper,
  SearchWrapper,
  SectionTitle,
  LocationsCounter,
  RowContainer,
  Row,
  TH,
  TD,
  PaginationWrapper,
  ButtonWrapper,
  Left,
  Right,
  CancelButton,
  CloseIcon,
  ActiveSwitchWrapper,
  RowWrapper,
} from './filterModalStyles';

import * as actions from '../../modules/MenuManagement/CombosManager/combosAction';
import { paginate } from './paginate';
import { fil } from 'date-fns/locale';

const initialRequestParams = {
  page_number: 1,
  page_size: '10',
  sorting_option: 'title-asc',
};
const FilterCombosModal = ({
  combosList,
  requestParams,
  filteredCombos,
  setFilteredCombos,
  isOpen,
  setIsOpen,
  placeholder,
  searchLabel,
  formField,
  isEmptyAccepted,
  getCombos,
  updateCombosRequestParams,
  setFieldValue,
  isSelectAllAvailable = true,
  emptyIsEqualToAll = true,
  handleSave,
  hasVisibleToggles = true,
}) => {
  delete requestParams.has_next_page;

  const [selectedCombos, setSelectedCombos] = useState(
    filteredCombos?.map((combo) => combo.combo_id) || []
  );
  const [searchedCombos, setSearchedCombos] = useState([]);
  const [showOnlyActive, setShowOnlyActive] = useState(false);
  const [showOnlySelected, setShowOnlySelected] = useState(false);

  const handleFilterSelected = useCallback(
    (e) => setShowOnlySelected(e.target.checked),
    []
  );

  const handleFilterActive = useCallback(
    (e) => setShowOnlyActive(e.target.checked),
    []
  );

  useEffect(() => {
    if (!combosList?.length > 0) {
      getCombos({
        page_number: 1,
        page_size: '4000',
        search_string: '',
      });
    }
    updateCombosRequestParams(initialRequestParams);
    return () => {
      updateCombosRequestParams(initialRequestParams);
    };
  }, []);
  //
  const updateInitials = useCallback(() => {
    let newCombosList = filteredCombos.map((combo) => combo.combo_id);
    if (combosList && filteredCombos?.length === 0 && emptyIsEqualToAll) {
      newCombosList = combosList.map((combo) => combo.id);
    }
    setSelectedCombos(newCombosList.sort());
    setSearchedCombos(newCombosList);
  }, [combosList, filteredCombos, emptyIsEqualToAll]);

  useEffect(() => {
    updateInitials();
  }, [updateInitials]);

  const [currentPageCombos, setCurrentPageCombos] = useState([]);
  const [comboListLength, setComboListLength] = useState([]);
  const [searchString, setSearchString] = useState('');

  //   callback 1

  const findIfMatches = useCallback(
    (item) => {
      const matchesSearch = searchString
        ? item.name.toLowerCase().includes(searchString.toLowerCase())
        : true;

      const matchesActive = !showOnlyActive || item.is_active;
      const matchesSelected =
        !showOnlySelected || selectedCombos.includes(item.id);

      return matchesSearch && matchesActive && matchesSelected;
    },
    [searchString, showOnlyActive, showOnlySelected, selectedCombos]
  );

  const handelPagination = (filteredList) => {
    const sortedCombos = filteredList.sort((a, b) =>
      a.name.localeCompare(b.name)
    );

    setSearchedCombos(sortedCombos);
    let paginatedList = paginate(
      filteredList,
      requestParams.page_number,
      requestParams.page_size
    );
    setCurrentPageCombos(paginatedList);
    setComboListLength(filteredList.length);
  };

  const filterComboList = useCallback(() => {
    let filteredList = combosList;
    filteredList = filteredList?.filter(findIfMatches);

    handelPagination(filteredList);
  }, [
    requestParams.page_number,
    requestParams.page_size,
    selectedCombos,
    JSON.stringify(combosList),
  ]);
  useEffect(() => {
    filterComboList();
  }, [filterComboList]);

  //use effect 2
  useEffect(() => {
    let filteredList;
    if (combosList?.length > 0) {
      filteredList = combosList?.filter((item) => {
        return findIfMatches(item);
      });
    }
    const sortedCombos = filteredList.sort((a, b) =>
      a.name.localeCompare(b.name)
    );
    setSearchedCombos(sortedCombos);
    const paginatedList = paginate(sortedCombos, 1, requestParams.page_size);
    updateCombosRequestParams({ ...requestParams, page_number: 1 });
    setCurrentPageCombos(paginatedList);
    setComboListLength(sortedCombos?.length || 0);
  }, [searchString, showOnlyActive, showOnlySelected]);
  ///
  const handleAssignCombos = (e, id) => {
    let newSelectedCombos = [...selectedCombos];
    let isSelected = selectedCombos.includes(id);
    if (isSelected) {
      newSelectedCombos = selectedCombos.filter(
        (currentId) => currentId !== id
      );
    } else {
      newSelectedCombos.push(id);
    }
    setSelectedCombos(newSelectedCombos);
  };
  const handleAssignCombosList = (e) => {
    let isSelected = e.target.checked;
    let newSelectedCombos = [];
    if (isSelected) {
      searchedCombos.map((combo) => {
        newSelectedCombos.push(combo.id);
      });
    }
    setSelectedCombos(newSelectedCombos);
  };
  const handleAddCombos = () => {
    let formattedSelectedItems = [];
    const comboListLength = combosList.length;
    const selectedCombosLength = selectedCombos.length;
    if (selectedCombosLength === 0) {
      formattedSelectedItems = null;
    } else if (
      selectedCombosLength === comboListLength &&
      selectedCombosLength !== 0 &&
      emptyIsEqualToAll
    ) {
      formattedSelectedItems = [];
    } else {
      selectedCombos.forEach((id) => {
        let newItem;
        newItem = { combo_id: id };
        formattedSelectedItems.push(newItem);
      });
    }
    if (handleSave) {
      console.log('formattedSelectedItems', formattedSelectedItems);
      handleSave(formattedSelectedItems);
    }
    setIsOpen(false);
  };
  const handleReset = () => {
    setSelectedCombos(filteredCombos.map((combo) => combo.combo_id));
  };
  const isSaveDisabled = () => {
    let isDisabled = true;
    let isEqual = _.isEqual(filteredCombos.sort(), selectedCombos.sort());

    if (combosList) {
      const isEmptyAccepted = true;
      if (true && !isEqual) {
        isDisabled = false;
      } else if (false && selectedCombos.length !== 0 && !isEqual) {
        isDisabled = false;
      }
    }
    isDisabled = false;
    return isDisabled;
  };
  console.log('requestParams', requestParams);
  return (
    <Dialog open={isOpen} fullWidth maxWidth='md'>
      <StyledCard>
        <HeaderWrapper padding='0'>
          <div>
            <SectionTitle>Combos</SectionTitle>
            <LocationsCounter>
              {`${selectedCombos.length} combo(s) selected`}
            </LocationsCounter>
          </div>
          <div style={{ textAlign: 'right' }}>
            <CloseIcon
              className='fa fa-times'
              onClick={() => setIsOpen(false)}
            ></CloseIcon>
          </div>
        </HeaderWrapper>
        <SearchWrapper>
          <TextField
            id='outlined-basic'
            label={searchLabel}
            placeholder={placeholder}
            variant='outlined'
            style={{ width: '100%' }}
            value={searchString}
            onChange={(e) => setSearchString(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position='start'>
                  <i className='fa fa-search' style={{ color: '#b5b5b5' }}></i>
                </InputAdornment>
              ),
              endAdornment: (
                <InputAdornment position='end'>
                  {`${comboListLength} results`}
                </InputAdornment>
              ),
            }}
          />
        </SearchWrapper>
        <ActiveSwitchWrapper
          style={{ display: hasVisibleToggles ? 'block' : 'none' }}
        >
          <FormControlLabel
            style={{
              mb: 1,
              minWidth: '300px',
              justifyContent: 'space-between',
            }}
            control={
              <Switch
                checked={showOnlyActive}
                onChange={(e) => handleFilterActive(e)}
                color='primary'
              />
            }
            label='Show active combos only'
          />
        </ActiveSwitchWrapper>
        <ActiveSwitchWrapper
          style={{ display: hasVisibleToggles ? 'block' : 'none' }}
        >
          <FormControlLabel
            style={{
              mb: 1,
              minWidth: '300px',
              justifyContent: 'space-between',
            }}
            control={
              <Switch
                checked={showOnlySelected}
                onChange={(e) => handleFilterSelected(e)}
                color='primary'
              />
            }
            label='Show selected combos only'
          />
        </ActiveSwitchWrapper>
        {isSelectAllAvailable && (
          <RowWrapper>
            <TH>
              <Checkbox
                checked={
                  searchedCombos.length === selectedCombos.length &&
                  selectedCombos.length !== 0
                }
                onChange={handleAssignCombosList}
                color='primary'
                style={{
                  transform: 'scale(1.3)',
                }}
              />
            </TH>
            <TH>Select All Combos</TH>
          </RowWrapper>
        )}
        {currentPageCombos.map((combo, index) => (
          <RowWrapper
            key={generateUniqueKey(index)}
            hoverBGColor='#f1f1fa'
            onClick={(e) => handleAssignCombos(e, combo.id)}
          >
            <TD bgColor='yellow'>
              <Checkbox
                checked={selectedCombos.includes(combo.id)}
                onChange={(e) => handleAssignCombos(e, combo.id)}
                color='primary'
                style={{
                  transform: 'scale(1.3)',
                }}
              />
            </TD>
            <TD isAssigned={selectedCombos.includes(combo.id)}>{combo.name}</TD>
          </RowWrapper>
        ))}
        <PaginationWrapper>
          <PaginationControl
            response={{
              ...currentPageCombos,
              page: requestParams.page_number,
              page_size: requestParams.page_size,
              count: combosList.length,
            }}
            requestParams={requestParams}
            // updateAction={getCombos}
            type='combos'
          />
        </PaginationWrapper>
        <ButtonWrapper>
          <Left>
            <CancelButton onClick={handleReset}>Cancel</CancelButton>
          </Left>
          <Right>
            <Button onClick={handleAddCombos}>Save</Button>
          </Right>
        </ButtonWrapper>
      </StyledCard>
    </Dialog>
  );
};
function mapStateToProps(state) {
  return {
    combosList: state.combosReducer.combosList,
    requestParams: state.combosReducer.requestParams,
  };
}
export default connect(mapStateToProps, actions)(FilterCombosModal);
